import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgEducation(props: RootSvgProps) {
  return (
    <RootSvg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_4628_55463)">
        <path
          d="M10.0007 2.5L0.833984 7.5L4.16732 9.31667V14.3167L10.0007 17.5L15.834 14.3167V9.31667L17.5007 8.40833V14.1667H19.1673V7.5L10.0007 2.5ZM15.684 7.5L10.0007 10.6L4.31732 7.5L10.0007 4.4L15.684 7.5ZM14.1673 13.325L10.0007 15.6L5.83398 13.325V10.225L10.0007 12.5L14.1673 10.225V13.325Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_4628_55463">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </RootSvg>
  );
}
